<template>
  <div class="publicItems">
    <div class="selectionArea">
      <div class="item">
        <span class="item_title">名称</span>
        <el-input v-model="parameter.name" />
      </div>
      <div class="item">
        <span class="item_title">关键词</span>
        <el-input v-model="parameter.key_words" />
      </div>
      <div class="item">
        <span class="item_title">投放组</span>
        <el-autocomplete
          v-model="group_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @clear="(parameter.group_id = null), (group_name = null)"
          @select="handleSelect"
        />
      </div>
      <div class="item">
        <span class="item_title">类型</span>
        <el-select
          v-model="parameter.type"
          placeholder="请选择"
          clearable
        >
          <el-option
            v-for="item in [{label:'头条',value:'1'},{label:'腾讯',value:'2'}]"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div class="item">
        <span class="item_title">状态</span>
        <el-select
          v-model="parameter.status"
          placeholder="请选择"
          clearable
        >
          <el-option
            v-for="item in [{label:'正常',value:'1'},{label:'禁用',value:'2'}]"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <el-button style="height:37px" type="primary" icon="el-icon-search" @click="getDataList">搜索</el-button>
      <el-button style="height:37px" type="primary" icon="el-icon-refresh-left" @click="reset">重置</el-button>
      <el-button style="height:37px" type="primary" icon="el-icon-circle-plus" @click="establish">创建</el-button>
    </div>
    <div>
      <el-table
        v-loading="loading"
        :data="tableData.list"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="name"
          label="名称"
        />
        <el-table-column
          prop="key_words"
          label="关键字"
        >
          <template scope="scope">
            <ExpandClose
              :my-values="scope.row.key_words"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="group_name"
          label="投放组"
        />
        <!-- <el-table-column
          prop="ocean_advertiser"
          label="广告主"
          min-width="150"
        >
          <template scope="scope">
            <ExpandClose
              :my-values="scope.row.ocean_advertiser.map((item)=>{
                return `${item.account_name}（${item.account_id}）`
              })"
            />
          </template>
        </el-table-column> -->
        <el-table-column
          prop="created_at"
          label="创建时间"
        />
        <el-table-column
          prop="updated_at"
          label="修改时间"
        />
        <el-table-column
          align="center"
          prop="type"
          label="类型"
        >
          <template scope="scope">
            {{ scope.row.type===1?'头条':"腾讯" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态"
        >
          <!-- <template scope="scope">
            {{ scope.row.status === 1 ? '正常' : '禁用' }}
          </template> -->
          <template scope="scope">
            <div style="position: relative; display: inline-block;">
              <el-switch
                v-model="scope.row.status"
                :width="60"
                active-color="#13ce66"
                inactive-color="rgb(191,191,191)"
                :active-value="1"
                :inactive-value="2"
                @change="statusChange(scope.row)"
              />
              <div
                v-if="scope.row.status === 1"
                style="color: #fff;position: absolute;top: 2px;left: 7px;"
              >正常</div>
              <div
                v-else
                style="color: #fff;position: absolute;top: 2px;right: 7px;"
              >禁用</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          min-width="100"
        >
          <template scope="scope">
            <el-button type="primary" size="mini" @click="modify(scope.row)">修改</el-button>
            <!-- <el-button type="primary" size="mini" @click="myDelete(scope.row)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination-right
      :total="tableData.count"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />

    <el-dialog
      :title="drawerItem && drawerItem.id ? '修改关系' : '创建关系'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="40%"
      style="min-width:680px"
      @closed="drawerItem = {}"
      @close="close"
    >
      <Details v-if="dialogVisible" ref="details" :drawer-item="drawerItem" @determine="determine" />
    </el-dialog>

  </div>
</template>

<script>
import { getRelationsList, addRelations, modifyRelations, modifyRelationsStatus, getReleaseGroupList } from '@/api/hugeAdvertGroup.js'
import { mapGetters } from 'vuex'
import PaginationRight from '@/components/PaginationRight/index.vue'
import ExpandClose from '@/components/ExpandClose/index.vue'
import Details from './components/details.vue'
export default {
  components: {
    PaginationRight,
    ExpandClose,
    Details
  },
  data() {
    return {
      tableData: {},
      loading: false,
      parameter: {
        page: 1,
        pageSize: 10,
        key_words: null,
        name: null,
        status: null,
        group_id: null,
        type: null
      },
      group_name: null,
      dialogVisible: false,
      drawerItem: {},
      isL: false
    }
  },
  created() {
    window.aa = this
    this.getDataList()
  },
  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters(['getBindingRelationship'])
  },
  methods: {
    // 获取数据列表
    async getDataList() {
      this.loading = true
      const data = await getRelationsList(this.parameter)
      this.tableData = data.data
      this.loading = false
    },
    // 投放组选搜索
    async querySearchAsync(queryString, cb) {
      const data = await getReleaseGroupList({
        name: queryString || null
      })
      cb(data.data.list.map((item) => {
        return {
          value: item.group_name,
          address: item.id
        }
      }))
    },
    // 选中哪一项
    handleSelect(item) {
      this.group_name = item.value
      this.parameter.group_id = item.address
    },
    // 修改
    modify(row) {
      this.dialogVisible = true
      this.isL = true
      this.drawerItem = row
    },
    // 分页
    fetchPageSize(s) {
      this.parameter.pageSize = s
      this.getDataList(true)
    },

    // 分页
    fetchCurrentPage(s) {
      this.parameter.page = s
      this.getDataList(true)
    },

    // 确定
    async determine(obj, start_time) {
      const bool = !!this.drawerItem.id
      if (bool) {
        await modifyRelations(this.drawerItem.id, obj)
      } else {
        await addRelations({ ...obj, start_time })
      }

      this.$message({
        message: bool ? '修改关系成功' : '创建关系成功',
        type: 'success'
      })
      this.isL = true
      this.drawerItem = {}
      this.dialogVisible = false
      this.getDataList()
    },

    // 重置
    reset() {
      this.parameter = {
        page: 1,
        pageSize: 10,
        key_words: null,
        name: null,
        status: null,
        group_id: null
      }
      this.group_name = null
      this.getDataList()
    },

    // 创建按钮的点击事件的处理函数
    establish() {
      // console.log('有无数据回显===', this.isL, this.drawerItem)
      this.drawerItem = this.getBindingRelationship || {}
      this.dialogVisible = true
      this.isL = false
    },

    close() {
      this.$store.commit('bindingRelationship/setLastCreatedData', this.$refs.details.createTheDesiredStructure(this.isL))
    },
    statusChange(row) {
      modifyRelationsStatus({ id: row.id, status: row.status })
        .then(res => {
          this.$message({
            message: '设置成功',
            type: 'success'
          })
        }
        )
        // .then(() => {
        //   this.parameter.status = null
        //   this.getDataList()
        // })
    }
  }
}
</script>
<style src="@/styles/public1.css"></style>

<style scoped lang="less">
.selectionArea{
  display: flex;
  flex-wrap: wrap;
  .item{
    display: flex;
    align-items: center;
    margin-right: 20px;
    margin-bottom: 10px;
    .item_title{
       margin-right: 5px;
       display: inline-block;
       width: 55px;
    }
    .item_input{
      width:200px
    }
  }
}
</style>

<style>
.publicItems .el-dialog{
  margin-top: 6vh !important;
  min-width: 685px !important;
}
</style>
